<div class="modal-shell__header">
  <h2 mat-dialog-title class="modal-shell__title">{{ config.title }}</h2>
  <p class="modal-shell__subtitle" *ngIf="config.subtitle">{{ config.subtitle }}</p>
</div>

<mat-dialog-content class="modal-shell__content">
  <ng-content select="[modal-content]"></ng-content>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-shell__actions">
  <ng-content select="[modal-actions]"></ng-content>
</mat-dialog-actions>
